import { Sound } from './audio';
import { Cosmos } from './fx';
import { scatter } from './layout';
import { mountDaily } from './daily';
import { mountPwa } from './pwa';
mountPwa();
const el = <T extends HTMLElement>(id:string) => document.getElementById(id) as T;
const intro=el('intro'), game=el('game'), result=el('result'), field=el('field'), reading=el('reading'), start=el<HTMLButtonElement>('start');
const sound=new Sound(), fx=new Cosmos(el<HTMLCanvasElement>('cosmos'));
let lines:string[][]=[], rubies:string[][]=[], line=0,index=0,done=0,total=0,mistakes=0,started=0,elapsed=0,playing=false,transitioning=false;
type Session = { line:number; elapsed:number; mistakes:number; scripture:string };
const sessionKey='heart-sutra-session-v1', settingsKey='heart-sutra-settings-v1';
let saved:Session|undefined, transitionTimer:ReturnType<typeof setTimeout>|undefined;
let timerVisible=true, largeRuby=false;
try {const settings=JSON.parse(localStorage.getItem(settingsKey)||'null');timerVisible=settings?.timerVisible!==false;largeRuby=settings?.largeRuby===true;} catch {}
function applySettings() {
 el('timer').hidden=!timerVisible;el<HTMLInputElement>('show-timer').checked=timerVisible;
 el<HTMLInputElement>('large-ruby').checked=largeRuby;el('app').classList.toggle('large-ruby',largeRuby);
 try {localStorage.setItem(settingsKey,JSON.stringify({timerVisible,largeRuby}));} catch {}
}
el('show-timer').onchange=()=>{timerVisible=el<HTMLInputElement>('show-timer').checked;applySettings();};
el('large-ruby').onchange=()=>{largeRuby=el<HTMLInputElement>('large-ruby').checked;applySettings();};
applySettings();
const scripture=()=>lines.map(l=>l.join('')).join('\n');
const activeElapsed=()=>elapsed+(playing?performance.now()-started:0);
function saveSession(nextLine:number) {
 saved={line:nextLine,elapsed:activeElapsed(),mistakes,scripture:scripture()};
 try {localStorage.setItem(sessionKey,JSON.stringify(saved));} catch {}
}
function advance() {
 if(!playing||!transitioning)return;
 clearTimeout(transitionTimer);transitionTimer=undefined;
 if(line+1===lines.length)finish();else {line++;spawn();}
}
field.onclick=()=>{if(transitioning)advance();};
function pause() {
 if(!playing)return;
 if(transitioning&&line+1===lines.length){advance();return;}
 const nextLine=transitioning?line+1:line;
 saveSession(nextLine);elapsed=activeElapsed();playing=false;
 clearTimeout(transitionTimer);transitioning=false;sound.setJourney(0,false);
 game.hidden=true;intro.hidden=false;
 showResume();
}
function showResume() {
 el('resume').hidden=!saved;
 if(saved)el('resume').textContent=`第${saved.line+1}節から再開`;
}
el('pause').onclick=pause;
el('resume').onclick=()=>begin(true);
document.addEventListener('visibilitychange',()=>{if(document.hidden&&playing)pause();});
const format=(ms:number)=>`${String(Math.floor(ms/60000)).padStart(2,'0')}:${String(Math.floor(ms/1000)%60).padStart(2,'0')}`;
function updateReading() {
 reading.replaceChildren();
 lines[line].forEach((char,i)=>{const ruby=document.createElement('ruby'),rt=document.createElement('rt');ruby.append(char);rt.textContent=rubies[line][i];ruby.append(rt);ruby.className=i<index?'done':i===index?'current':'';reading.append(ruby);});
 el('line-count').textContent=`${String(line+1).padStart(2,'0')} / ${lines.length} 節`;
 el('progress').style.width=`${done/total*100}%`;
}
function positionCharacters() {
 const buttons=Array.from(field.querySelectorAll<HTMLButtonElement>('.kanji'));
 if (!buttons.length || !field.clientWidth || !field.clientHeight) return;
 const diameter=buttons[0].offsetWidth,cols=Math.max(1,Math.floor((field.clientWidth-10)/(diameter+10)));
 const needed=Math.ceil(buttons.length/cols)*(diameter+10)+10;
 if(field.style.minHeight!==`${needed}px`)field.style.minHeight=`${needed}px`;
 const points=scatter(buttons.length,field.clientWidth,field.clientHeight,buttons[0].offsetWidth);
 buttons.forEach((b,i)=>{b.style.left=`${points[i].x}px`;b.style.top=`${points[i].y}px`;});
}
function spawn() {
 index=0;transitioning=false;field.replaceChildren();
 lines[line].forEach((char,i)=>{const b=document.createElement('button');b.className='kanji';b.textContent=char;b.setAttribute('aria-label',`${char}を選ぶ`);b.style.animationDelay=`${i*.025}s`;b.onclick=event=>{event.stopPropagation();if(transitioning)advance();else choose(b);};field.append(b);});
 positionCharacters();updateReading();sound.setJourney(done/total,true);
}
function choose(button:HTMLButtonElement) {
 if(!playing||transitioning||button.disabled)return;
 if(button.textContent!==lines[line][index]) {
  mistakes++;sound.wrong();button.classList.remove('wrong');void button.offsetWidth;button.style.animationDelay='0s';button.classList.add('wrong');return;
 }
 const rect=button.getBoundingClientRect(),app=el('app').getBoundingClientRect();
 fx.burst(rect.x-app.x+rect.width/2,rect.y-app.y+rect.height/2);
 button.disabled=true;button.style.animationDelay='0s';button.className='kanji accepted';sound.correct(index);index++;done++;updateReading();
 if(index===lines[line].length){transitioning=true;sound.complete();fx.celebrate(app.width/2,app.height*.43);if(line+1<lines.length)saveSession(line+1);transitionTimer=setTimeout(advance,1800);}
}
function begin(resume=false) {
 clearTimeout(transitionTimer);
 line=resume&&saved?saved.line:0;index=0;done=lines.slice(0,line).reduce((n,l)=>n+l.length,0);mistakes=resume&&saved?saved.mistakes:0;elapsed=resume&&saved?saved.elapsed:0;started=performance.now();playing=true;saveSession(line);
 intro.hidden=true;result.hidden=true;game.hidden=false;el('timer').textContent='00:00';spawn();
 const rect=el('app').getBoundingClientRect();fx.burst(rect.width/2,rect.height*.43,true);
}
function finish() {
 elapsed=activeElapsed();playing=false;sound.endJourney();saved=undefined;try{localStorage.removeItem(sessionKey);}catch{}showResume();game.hidden=true;result.hidden=false;
 el('score').textContent=`${total}文字 · ${format(elapsed)} · 正解率 ${Math.round(total/(total+mistakes)*100)}%`;
 daily.complete();
}
start.onclick=()=>begin();el('restart').onclick=()=>begin();el('result-book').onclick=()=>el<HTMLDialogElement>('daily-dialog').showModal();
el('sound').onclick=async()=>{try{await sound.toggle();el('sound').textContent=sound.enabled?'音 ON':'音 OFF';el('sound').setAttribute('aria-pressed',String(sound.enabled));}catch(e){console.error(e);}};
new ResizeObserver(()=>{if(playing)positionCharacters();}).observe(field);
setInterval(()=>{if(playing)el('timer').textContent=format(activeElapsed());},250);
async function load() {
 try {
  const responses=await Promise.all(['sutra','ruby'].map(name=>fetch(`assets/${name}.txt`)));
  if(responses.some(r=>!r.ok))throw new Error('経文を読み込めませんでした');
  const [sutra,ruby]=await Promise.all(responses.map(r=>r.text()));
  lines=sutra.trim().split(/\r?\n/).map(l=>Array.from(l.trim()));rubies=ruby.trim().split(/\r?\n/).map(l=>l.trim().split(/\s+/));
  if(lines.length!==rubies.length||lines.some((l,i)=>l.length!==rubies[i].length))throw new Error('経文とルビの対応が一致しません');
  total=lines.reduce((n,l)=>n+l.length,0);
  try {const candidate=JSON.parse(localStorage.getItem(sessionKey)||'null');if(candidate&&candidate.scripture===scripture()&&Number.isInteger(candidate.line)&&candidate.line>=0&&candidate.line<lines.length&&Number.isFinite(candidate.elapsed)&&candidate.elapsed>=0&&Number.isSafeInteger(candidate.mistakes)&&candidate.mistakes>=0)saved=candidate;}catch{}
  showResume();start.disabled=false;start.textContent='はじめる';
 } catch(e) {start.textContent='再読み込み';start.disabled=false;start.onclick=()=>location.reload();intro.querySelector('.description')!.textContent='経文を読み込めませんでした。再読み込みしてください。';console.error(e);}
}
void load();

const daily=mountDaily(()=>sound.stamp(),()=>sound.pages());
